import { ReadRecruitmentReportByMetroActionTypes, RecruitmentReportByMetroState, READ_RECRUITMENT_REPORT_BY_METRO_DATA_REQUEST, READ_RECRUITMENT_REPORT_BY_METRO_DATA_SUCCESS, READ_RECRUITMENT_REPORT_BY_METRO_DATA_FAILURE } from "store/reducers/types/dashboard/recruitmentReportByMetro";

const defaultState: RecruitmentReportByMetroState = {
  isLoading: false,
  errorMessage: ""
};

export default function recruitmentReportByMetro(state = defaultState, action: ReadRecruitmentReportByMetroActionTypes): RecruitmentReportByMetroState {
  switch (action.type) {
    case READ_RECRUITMENT_REPORT_BY_METRO_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_RECRUITMENT_REPORT_BY_METRO_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_RECRUITMENT_REPORT_BY_METRO_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
